import styled from 'styled-components/macro';

const AddButton = styled.button`
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  width: 44px;
  height: 28px;
  border-style: none;
  background-color: transparent;
  margin-top: calc(-28px / 2);
  transform: translate3d(-50%, 0, 0);
  transition: color 0.15s ease-out;
  color: ${props => props.active ? '#fff' : 'rgba(255, 255, 255, 0.4)'};

  &:hover {
    color: #fff;
  }
`;

export default AddButton;
